import React, { FC, memo } from "react"
import { Space, Tag } from "antd"
import { COUNTRY_CODES } from "utils/countryCodes"

interface CountryTagListProps {
  countries: string[]
  color?: string
  emptyText?: string
}

export const CountryTagList: FC<CountryTagListProps> = memo(({
  countries,
  color = "blue",
  emptyText = "No countries",
}) => {
  if (countries.length === 0) {
    return <span style={{ color: "#999" }}>{emptyText}</span>
  }

  return (
    <Space wrap>
      {countries.map(code => {
        const country = COUNTRY_CODES.find(c => c.code === code)

        return (
          <Tag key={code} color={color}>
            {country ? `${country.name} (${code})` : code}
          </Tag>
        )
      })}
    </Space>
  )
})

CountryTagList.displayName = "CountryTagList"
